// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__JW6cR","input":"styles_input__3_fBs","button":"styles_button__zCjiZ"};